import { atom } from 'recoil';

export interface IAsset {
  VehicleId: string;
  AccountId: string;
  AccountName: string;
  VehiclePlate: string;
  VehicleCode: string;
  FleetName: string;
  Make: string;
  Model: string;
  RucMonkeyVehicleTypeId: string;
  RucMonkeyVehicleTypeName: string;
  SensorId: string;
  SensorSerialNumber: string;
}

export const assetTabListState = atom<IAsset[]>({
  key: "assetTabListState",
  default: [],
});

export const assetTabIndexState = atom<number>({
  key: "assetTabIndexState",
  default: 0,
});


export const assetListRefreshState = atom({
  key: "assetListRefreshState",
  default: true,
});